<div class="u-borderBottom-grey100" mat-dialog-title>
  {{ group.name }}
</div>
<mat-dialog-content class="u-borderBottom-grey100 u-showScrollBar">
  <app-profile-hub-item
    *ngIf="membership"
    [groupMembership]="membership"
    [profile]="profile"
    [isUser]="profile._id === user._id"
    [user]="user"
    [isIntroOnly]="data?.isIntroOnly"
    (remove)="closeDialog($event)"
    class="u-display-block"
  >
  </app-profile-hub-item>
</mat-dialog-content>
<mat-dialog-actions
  *ngIf="profile._id === user._id || user.isAdmin"
  fxLayout="row"
  fxLayoutAlign="start center"
>
  <button i18n="@@global.done" mat-button mat-dialog-close color="primary">
    Done
  </button>
</mat-dialog-actions>
